import NYCTimesDashboardView from "src/sections/dashboards/platforms/nyc-times/nyc-times-dashboard-view";

const NYCTimesMainDashboardPage = () => <NYCTimesDashboardView type="main" />;

export default NYCTimesMainDashboardPage;
